import EditorField from "../../Utils/EditorField"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
const SubstanceUse = ({ formik }) => {
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <EditorField
          value={formik.values.substanceUse_1}
          onTextChange={formik.setFieldValue}
          valueName={careerProfileLabels.substanceUse.substanceUse_1.value}
          label={careerProfileLabels.substanceUse.substanceUse_1.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.substanceUse_2}
          onTextChange={formik.setFieldValue}
          valueName={careerProfileLabels.substanceUse.substanceUse_2.value}
          label={careerProfileLabels.substanceUse.substanceUse_2.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.substanceUse_3}
          onTextChange={formik.setFieldValue}
          valueName={careerProfileLabels.substanceUse.substanceUse_3.value}
          label={careerProfileLabels.substanceUse.substanceUse_3.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.substanceUse_4}
          onTextChange={formik.setFieldValue}
          valueName={careerProfileLabels.substanceUse.substanceUse_4.value}
          label={careerProfileLabels.substanceUse.substanceUse_4.label}
        />
      </div>
    </>
  )
}
export default SubstanceUse
